import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation, Navigate } from "react-router-dom";
import Lenis from "lenis";
import { motion } from "framer-motion";
import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";
import { Toaster } from "@/components/ui/sonner";
import Home from "@/pages/Home";
import About from "@/pages/About";
import Capabilities from "@/pages/Capabilities";
import Products from "@/pages/Products";
import Quality from "@/pages/Quality";
import Contact from "@/pages/Contact";

const ScrollToTop = () => {
    const { pathname } = useLocation();
    useEffect(() => {
        window.scrollTo(0, 0);
    }, [pathname]);
    return null;
};

const PageFade = ({ children }) => {
    const { pathname } = useLocation();
    return (
        <motion.div
            key={pathname}
            initial={{ opacity: 0, y: 14 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, ease: [0.22, 1, 0.36, 1] }}
        >
            {children}
        </motion.div>
    );
};

function App() {
    useEffect(() => {
        const lenis = new Lenis({ lerp: 0.09, smoothWheel: true });
        let frame;
        const raf = (time) => {
            lenis.raf(time);
            frame = requestAnimationFrame(raf);
        };
        frame = requestAnimationFrame(raf);
        return () => {
            cancelAnimationFrame(frame);
            lenis.destroy();
        };
    }, []);

    return (
        <div className="App">
            <BrowserRouter>
                <ScrollToTop />
                <Navbar />
                <main>
                    <PageFade>
                        <Routes>
                        <Route path="/" element={<Home />} />
                        <Route path="/about" element={<About />} />
                        <Route path="/capabilities" element={<Capabilities />} />
                        <Route path="/products" element={<Products />} />
                        <Route path="/quality" element={<Quality />} />
                        <Route path="/infrastructure" element={<Navigate to="/quality" replace />} />
                        <Route path="/industries" element={<Navigate to="/quality" replace />} />
                        <Route path="/contact" element={<Contact />} />
                        </Routes>
                    </PageFade>
                </main>
                <Footer />
                <Toaster position="bottom-right" theme="dark" />
            </BrowserRouter>
        </div>
    );
}

export default App;
